import type { ComponentProps } from 'react'

type TextLinkProps = Omit<ComponentProps<'a'>, 'className'>

/** The quiet underlined link beneath a form: forgot password, back to sign in. */
export function TextLink(props: TextLinkProps) {
  return <a {...props} className="text-sm text-ink underline underline-offset-2 hover:text-brand" />
}
